export * from './tor24Teams';
export * from './tor24Matches';
export * from './setTor24Team';
export * from './setExternalReference';
export * from './deleteExternalSystemReference';
export * from './dfbClubs';
export * from './ExternalTeams';
